import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  RcsBroadcast,
  RcsBroadcastMessage,
  RcsBroadcastMessageFilters,
  RcsBroadcastRequest,
  RcsContent,
  RcsEstimate,
  RcsPage,
  RcsPreview,
} from 'src/app/models/Rcs';
import { environment } from 'src/environments/environment';

/** Prévia, custo e envio em massa do RCS (`/api/rcs/preview`, `/estimate`, `/broadcasts`). */
@Injectable({ providedIn: 'root' })
export class RcsBroadcastService {

  private readonly baseUrl = `${environment.apiUrl}/rcs`;

  constructor(private http: HttpClient) {}

  /** Formato, motivos e o SMS de fallback com o contato de exemplo. */
  preview(agentId: string | null, content: RcsContent): Observable<RcsPreview> {
    // `no-toast`: a prévia roda a cada tecla (debounce); o 422 aparece ao lado da prévia,
    // não num toast empilhado por requisição.
    return this.http.post<RcsPreview>(`${this.baseUrl}/preview?no-toast=1`, { agent_id: agentId, content });
  }

  /** Custo em faixa, pela divisão RCS × SMS que o cache de 30 dias prevê. */
  estimate(listId: string, content: RcsContent, agentId: string | null = null): Observable<RcsEstimate> {
    // `no-toast`: o 422 do custo já aparece dentro da caixa de custo. Com o agente, o backend
    // diz também se a rota RCS do cliente tem algum broker com a marca ativa (`route_blocked`).
    return this.http.post<RcsEstimate>(`${this.baseUrl}/estimate?no-toast=1`, { list_id: listId, agent_id: agentId, content });
  }

  list(page = 1): Observable<RcsPage<RcsBroadcast>> {
    const params = new HttpParams().set('page', String(page));
    return this.http.get<RcsPage<RcsBroadcast>>(`${this.baseUrl}/broadcasts`, { params });
  }

  /** 201: a carteira já reservou o máximo da faixa. */
  create(request: RcsBroadcastRequest): Observable<RcsBroadcast> {
    return this.http.post<RcsBroadcast>(`${this.baseUrl}/broadcasts`, request);
  }

  find(id: string): Observable<RcsBroadcast> {
    return this.http.get<RcsBroadcast>(`${this.baseUrl}/broadcasts/${id}`);
  }

  messages(id: string, page = 1, perPage?: number, filters: RcsBroadcastMessageFilters = {}): Observable<RcsPage<RcsBroadcastMessage>> {
    let params = new HttpParams().set('page', String(page));
    if (perPage) {
      params = params.set('per_page', String(perPage));
    }
    for (const key of ['phone', 'status', 'channel'] as const) {
      const value = (filters[key] || '').trim();
      if (value) {
        params = params.set(key, value);
      }
    }
    return this.http.get<RcsPage<RcsBroadcastMessage>>(`${this.baseUrl}/broadcasts/${id}/messages`, { params });
  }
}
